import ReactDOM from "react-dom";
import { INPUT_TYPE } from "deskera-ui-library";
import { FULL_MONTHS } from "../../constants/Constant";
import TenantManager from "../../managers/TenantManager";

import moment from 'moment';
import FormatCurrencyService from "../../services/FormatCurrencyService";
import { CALENDAR_VIEW, ENTRY_STATUS } from "./TimesheetConstants";
import { DKIcons, DKIcon, DKTooltipWrapper } from 'deskera-ui-library'
import Utility from "../../utility/Utility";
import ViewTimesheetEntry from "./reports/ViewTimesheetEntry";
import AddTimesheetEntry from "./timesheet-entry/AddTimesheetEntry";
import { TIMESHEET_CONSTANTS } from "./TimesheetService";
import ic_check_mark from "../../assets/icons/check.svg";
import ic_check_mark_circle_done from "../../assets/icons/white/ic_check-mark_circle_done.png";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

class TimesheetUtils {
    static isTrackLocation() {
        return TenantManager.getTenantDetails()?.additionalSettings?.LOCATION?.trackLocation;
    }
    
    static getLocationLabel() {
        return TenantManager.getTenantDetails()?.additionalSettings?.LOCATION?.locationLabel;
    }

    static getProjectsRowData(projects) {
        const rowData = [];
        if (projects && projects.length > 0) {
            projects.forEach((project) => {
                const row = {
                    name: project.name,
                    code: project.code,
                    customer: [project.customer],
                    location: [project.location],
                    isBillable: project.isBillable ? "Yes" : "No",
                    class: project.class,
                    project: project,
                    id: project.id
                };

                rowData.push(row);
            });
        }

        return rowData;
    }

    static parseLocationList(locations) {
        const options = [
            {
                value: "",
                label: "None"
            }
        ];
    
        if(Array.isArray(locations)) {
            locations.forEach(location => {
                options.push({
                    value: location.id,
                    label: location.label
                });
            });
        }
    
        return options;
    }

    static enrichWithLocation(state, locations) {
        state["location"] = {
            id: "location",
            title: TimesheetUtils.getLocationLabel(),
            type: INPUT_TYPE.DROPDOWN,
            options: this.parseLocationList(locations),
            value: "None"
        }
    }

    static getMonthAndYearString(month, year) {
        return `${FULL_MONTHS[month]} ${year}`;
    }

    static formatNumber(number) {
        if (typeof number === "number") {
            return number.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping:false });
        }

        return number;
    }

    static getTimeInString(timer) {
        const seconds = this.formatNumber(Math.floor(timer % 3600 % 60));
        const minutes = this.formatNumber(Math.floor(timer % 3600 / 60));
        const hours = this.formatNumber(Math.floor(timer / 3600));

        return `${hours}:${minutes}:${seconds}`;
    }

    static getWorkHoursInString(timer) {
        const seconds = this.formatNumber(Math.floor(timer % 3600 % 60));
        const minutes = this.formatNumber(Math.floor(timer % 3600 / 60));
        const hours = this.formatNumber(Math.floor(timer / 3600));

        return `${hours}h ${minutes}m ${seconds}s`;
    }

    static getTasksRowData(tasks) {
        const rowData = [];
        if (tasks && tasks.length > 0) {
            tasks.forEach((task) => {
                const row = {
                    name: task.name,
                    description: task.description,
                    projectId: [task.projectId],
                    isBillable: task.isBillable ? "Yes" : "No",
                    task: task,
                    id: task.id
                };

                rowData.push(row);
            });
        }

        return rowData;
    }

    static getEmployeeMappingRowData(mappings, users) {
        const rowData = [];
        if (mappings && mappings.length > 0) {
            mappings.forEach((mapping) => {
                const row = {
                    employeeId: Array.isArray(users) ? users.find((u) => u.userId === mapping.employeeId).name : "",
                    customer: [mapping.customer],
                    projectId: [mapping.projectId],
                    ratePerHour: FormatCurrencyService.format(mapping.ratePerHour),
                    mapping: mapping,
                    id:mapping.id
                };

                rowData.push(row);
            });
        }

        return rowData;
    }

    static getTimesheetEntryRowData(entries, tasks, functionConfig) {
        const rowData = [];
        if (entries && entries.length > 0) {
            entries.forEach((entry) => {
                const task = this.findTask(tasks, entry.jobId);
                const row = {
                    description: task?.name ,
                    projectId: entry?.projectName,
                    customer: entry?.customerName,
                    entryDate: (entry.fromDate),
                    fromDate: moment((entry.fromDate)).format("hh:mm A"),
                    toDate: entry.toDate ? moment((entry.toDate)).format("hh:mm A") :"-",
                    seconds: this.getTimeInString(entry.seconds),
                    isBillable: entry.isBillable ? "Yes" : "No",
                    status: [entry.status],
                    timesheetEntry: entry,
                    rowContextMenu: TimesheetUtils.getContextMenuButton(functionConfig,entry)
                    
                };

                rowData.push(row);
            });
        }

        return rowData;
    }

    static getContextMenuButton(functionConfig,entry) {
        let contextButtons = [];
        if(entry.status === TIMESHEET_CONSTANTS.DRAFT || entry.status === TIMESHEET_CONSTANTS.REJECTED ) {
            contextButtons.push(
                {
                    title: "Submit",
                    icon: ic_check_mark,
                    onClick: (data) => {
                      functionConfig.onSubmit(data);
                    },
                }
            )
        }
        if(entry.status !== TIMESHEET_CONSTANTS.APPROVED && entry.status !== TIMESHEET_CONSTANTS.REJECTED && entry.status !== TIMESHEET_CONSTANTS.SUBMITTED) {
            contextButtons.push({
                title: "Delete",
                icon: DKIcons.ic_delete,
                onClick: (data) => {
                  functionConfig.onRowDelete(data);
                }
            })
        }
        return contextButtons
    }
    static getReportContextMenuButton = (row,functionConfig) =>{
        let contextButtons = [];
        const deleteBtn = {
            title: "Delete",
            icon: DKIcons.ic_delete,
            onClick: (data) => {
              functionConfig?.onRowDelete(data);
            },
        }
        const reject = {
            title: "Reject",
            icon: DKIcons.ic_close,
            onClick: (data) => {
              functionConfig.onApproveReject(data,false);
            },
        }
        const approve = {
            title: "Approve",
            icon: ic_check_mark,
            onClick: (data) => {
              functionConfig.onApproveReject(data,true);
            },
        }
        const submit = {
            title: "Submit",
            icon: ic_check_mark_circle_done,
            onClick: (data) => {
              functionConfig.onSubmit(data);
            },
        }
        switch(row.status) {
            case TIMESHEET_CONSTANTS.SUBMITTED:
                if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.APPROVE])) {
                    contextButtons = [...contextButtons,approve]
                }
                if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.REJECT])) {
                    contextButtons = [...contextButtons,reject]
                }
                if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.DELETE])) {
                    contextButtons = [...contextButtons,deleteBtn]
                }
                
                break;
            case TIMESHEET_CONSTANTS.APPROVED:
                if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.REJECT])) {
                    contextButtons = [reject]
                }
                break;
            case TIMESHEET_CONSTANTS.REJECTED:
                if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.APPROVE])) {
                    contextButtons = [approve]
                }
                if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.DELETE])) {
                    contextButtons = [...contextButtons,deleteBtn]
                    
                }
                break;
        }
        
        return contextButtons
    }
    static monthTaskRenderer(entry) {
        return `<div class="parent-width row bg-gray2 border-radius-s task-container" style="padding: 3px 8px;">
            <div class="ellipsis pr-s" style="max-width: calc(100% - 60px); min-width: calc(100% - 60px)">
                &#9679;&nbsp;${entry.jobName}
            </div>
            <div class="ellipsis text-align-right" style="max-width: 60px; min-width: 30px">
                ${!Utility.isEmpty(entry.toDate) ? TimesheetUtils.getTimeInString(entry.seconds) : "-"}
            </div>
        </div>`;
    }

    static calculateMinMax(data) {
            data = data >60 ? data+(((data/40)*2)+2 ) : data ;
            data = parseFloat(((data*40)/60).toFixed(2));
            return data;
    }

    static dayAndWeekTaskRenderer(entry,view,deleteEntry,date,onSubmit) {
        const isDayView = view ? view === CALENDAR_VIEW.DAY:false
        const isWeekView = view ? view === CALENDAR_VIEW.WEEK:false
        let start = entry.fromDate;
        let end = entry.toDate ? entry.toDate : moment().utc().format() ;
        let minH = 5;
        let maxH = 17;
        let isBetWeen = false;
        let isSameToDate = false;
        let isFromToSame = false;
        
        if(date) {
            const day = (date);
            const taskFromDate = new Date(moment(entry.fromDate).format());
            const taskToDate = new Date(moment(entry.toDate).format());
            let tFromDate = `${taskFromDate.getDate()}/${taskFromDate.getMonth()+1}/${taskFromDate.getFullYear()}`;
            let tToDate = `${taskToDate.getDate()}/${taskToDate.getMonth()+1}/${taskToDate.getFullYear()}`;
            let currentDate = `${day.getDate()}/${day.getMonth()+1}/${day.getFullYear()}`
            isBetWeen = (moment(currentDate,'DD/MM/YYYY').isBetween(moment(tFromDate,'DD/MM/YYYY'),moment(tToDate,'DD/MM/YYYY')))
            isSameToDate = (moment(currentDate,'DD/MM/YYYY').isSame(moment(tToDate,'DD/MM/YYYY')))
            isFromToSame = (moment(tFromDate,'DD/MM/YYYY').isSame(moment(currentDate,'DD/MM/YYYY')))
        }
        if(start && end) {
            let entryFromDate = entry.fromDate
            //min
            if(isSameToDate && !isFromToSame) {
                start = moment().format('YYYY-MM-DDT00:00:00');
                entryFromDate = start;
            }
            minH = moment(end).diff(moment(start),'minute');
            minH = TimesheetUtils.calculateMinMax(minH);

            //max
            let maxTime = moment(entryFromDate).format('YYYY-MM-DD 23:59')
            maxH = moment(maxTime).diff(moment(start),'minute');
            maxH = TimesheetUtils.calculateMinMax(maxH);

            if(minH>maxH) {
                minH = maxH
            }
            if(isBetWeen) {
                minH = maxH = 1020;
            }
        }

        return (
            <div className={`d-flex mr-m  border-radius-s  border-m z-index-1 ${TimesheetUtils.getColorBasedOnStatus(entry.status,isDayView)}`}  style={{width: `${isDayView ? "98%":""}`, padding: "0px 8px",minHeight:minH,maxHeight:maxH, position:'absolute', top:TimesheetUtils.getCurrentTimePosistion(40,entry.fromDate)}}>
                <span className="ellipsis" style={{ maxWidth: !isDayView ?"60px":"", minWidth: "60px" }}>
                    &#9679;&nbsp;{entry.jobName}
                </span>
                {(isDayView && entry.projectName)&&<span className="ellipsis pl-l" style={{ maxWidth: !isDayView ?"60px":"", minWidth: "60px" }}>
                    &#9679;&nbsp;{entry.projectName}
                </span>}
                {(isDayView && entry.customerName)&&<span className="ellipsis pl-l" style={{ maxWidth: !isDayView ?"60px":"", minWidth: "60px" }}>
                    &#9679;&nbsp;{entry.customerName}
                </span>}
                {(isDayView && entry.status)&&<span className="ellipsis pl-l" style={{ maxWidth: !isDayView ?"60px":"", minWidth: "60px" }}>
                    &#9679;&nbsp;{entry.status}
                </span>}
                <span className="ellipsis text-align-right" style={{ maxWidth: "60px", minWidth: "60px" }}>
                    {!Utility.isEmpty(entry.toDate) ? TimesheetUtils.getTimeInString(entry.seconds) : "-"}
                </span>
                {(isDayView && entry.status === TIMESHEET_CONSTANTS.DRAFT )&&<span className="ellipsis pl-l" style={{ maxWidth: !isDayView ?"20px":"", minWidth: "20px" }}>
                    &nbsp;<DKIcon className="ic-xs cursor-hand" src={DKIcons.ic_delete} onClick={(e)=>{
                        if(deleteEntry) {
                            e.stopPropagation();deleteEntry(entry)
                        }
                    }}/>
                </span>}
                {(isDayView && (entry.status === TIMESHEET_CONSTANTS.DRAFT || entry.status === TIMESHEET_CONSTANTS.REJECTED )) && <span className="ellipsis pl-l" style={{ maxWidth: !isDayView ? "20px" : "", minWidth: "20px" }}>
                <DKIcon className="ic-xs cursor-hand" src={ic_check_mark} onClick={(e) => {
                            if (onSubmit) {
                                e.stopPropagation(); onSubmit({ rowData: { timesheetEntry: entry } })
                            }
                        }} />
                </span>

                }
            </div>
        );
    }

    static getColorBasedOnStatus (status,isDayView) {
        
        switch(status) {
            case ENTRY_STATUS.REJECTED:
                return "entry-status rejected";
            case ENTRY_STATUS.APPROVED:
                return "entry-status approved";
            case ENTRY_STATUS.DRAFT:
                return "entry-status draft";
            case ENTRY_STATUS.SUBMITTED:
                return 'entry-status submitted' ;
            default:
                return 'bg-light-app text-app' ;            
        }
    }

    static getCurrentTimePosistion(timeLineHeight=40,startFrom) {
        if(startFrom) {
            // console.log(startFrom.replace("Z",""))
        }
        let from = startFrom ? moment(startFrom).format('mm') : moment().format('mm')
        const top = ((parseInt(from) * timeLineHeight) / 60).toFixed(2)
        return parseFloat(top)
    }

    static findTask(tasks, taskId) {
        let task;

        if (Array.isArray(tasks)) {
            task = tasks.find((task) => task.id === taskId);
        }

        return task;
    }

    static findProject(projects, projectId) {
        let project;

        if (Array.isArray(projects)) {
            project = projects.find((p) => p.id === projectId);
        }

        return project;
    }

    static findCustomer(customers, customerId) {
        let customer;

        if (Array.isArray(customers)) {
            customer = customers.find((c) => String(c.id) === customerId);
        }

        return customer;
    }

    static showViewTimesheetEntryPopup(config) {
        const div = document.createElement("div");
        div.className = "app-font";
        const elementId = "view-timesheet-entry-popup";
        div.setAttribute("id", elementId);

        ReactDOM.render(
            <ViewTimesheetEntry
                {...config}
                elementId={elementId}
            />,
            document.body.appendChild(div)
        );
    }
}

export default TimesheetUtils;
